import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {

  @HostBinding('class.fileover') fileOver: boolean;
  @Input() disabled: boolean = false;
  @Input() inactiveBackgroundColor: string = '#FFF1EB';
  @Input() activeBackgroundColor: string = '#FFFFFF'

  @Output() onFileDropped: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('style.background-color') private background;
  @HostBinding('style.opacity') private opacity: string = '0.7'

  constructor() {
    this.background = this.inactiveBackgroundColor;
  }

  @HostListener('mouseover', ['$event']) onMouseOver(evt): void {
    evt.preventDefault();
    evt.stopPropagation();

    if (!this.disabled) {
      this.background = this.activeBackgroundColor;
      this.opacity = '1';
    }
    this.fileOver = true;
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(evt): void {
    this.mouseAndDragLeave(evt);
  }

  @HostListener('dragover', ['$event']) onDragOver(evt): void {
    evt.preventDefault();
    evt.stopPropagation();

    if (!this.disabled) {
      this.background = this.activeBackgroundColor;
      this.opacity = '1'
    }
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event']) onDragLeave(evt): void {
    this.mouseAndDragLeave(evt);
  }

  @HostListener('drop', ['$event']) onDrop(evt): void {
    evt.preventDefault();
    evt.stopPropagation();

    this.background = this.inactiveBackgroundColor;
    this.opacity = '0.7'
    this.fileOver = false;

    if (!this.disabled) {
      let files = evt.dataTransfer.files;
      if (files.length > 0) {
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
          this.onFileDropped.emit(files);
        }
      }
    }
  }

  private mouseAndDragLeave(evt): void {
    evt.preventDefault();
    evt.stopPropagation();

    this.background = this.inactiveBackgroundColor;
    this.opacity = '0.7';
  }

}
